
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-fees",
      function () {
        return require("private-next-pages/service-fees.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-fees"])
      });
    }
  